import { render, staticRenderFns } from "./Varsler.vue?vue&type=template&id=5ece871a&scoped=true"
import script from "./Varsler.vue?vue&type=script&lang=js"
export * from "./Varsler.vue?vue&type=script&lang=js"
import style0 from "./Varsler.vue?vue&type=style&index=0&id=5ece871a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ece871a",
  null
  
)

export default component.exports